// extracted by mini-css-extract-plugin
module.exports = {"root":"SEOBreadcrumbs_root__CG5cP","breadcrumbs":"SEOBreadcrumbs_breadcrumbs__1pEoZ"};